import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApBaseComponent } from 'webcommon/core-ui';
import { NgForm } from '@angular/forms';
import { ApTinyEditorComponent } from 'webcommon/macro';

@Component({
  selector: 'ap-html-text-editor',
  templateUrl: './ap-html-text-editor.component.html',
})

  // Component to use Tiny HTML Editor without Macros.
  // Do not what components to call ap-tiny-editor directly.
export class ApHtmlTextEditorComponent extends ApBaseComponent {
  @Input() editorValue: string | null;
  @Input() height: number;
  @Input() hideToolbar = true;
  @Input() hideStatusBar = false;
  @Input() disabled = false;
  @Input() editorName: string;
  @Input() displayName: string;
  @Input() setFocusOnInit = true;               // sets the focus when the editor is initialized (useful for modal)
  @Input() setFocusOnInitCursorAtEnd = true;    // when setFocusOnInit is enabled, puts cursor at end of text
  @Input() autoResize = false;
  @Input() autoResizeMaxHeight: number | null = null;
  @Input() autoResizeMinHeight: number | null = null;
  @Input() required = false;
  @Input() form?: NgForm;
  @Output() dirtyChanged: EventEmitter<void> = new EventEmitter();
  @Output() htmlContentChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() textContentChanged: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('apTinyEditor') apTinyEditor: ApTinyEditorComponent;
  previousValue = '';
  isDirty = false;

  onEditorValueChanged(value: string) {
    if (value === this.editorValue) return;
    if (!this.isDirty) {
      this.isDirty = true;
      this.dirtyChanged?.emit();
    }
    // Should only use one of htmlContentChanged or textContentChanged at most
    // Text is assumed to be in html as this is an HTML Editor.
    // Prefer using getContents instead when edit is done (on save or close)
    this.htmlContentChanged?.emit(value);
    if (this.textContentChanged) {
      this.textContentChanged.emit(this.apTinyEditor.getContentAsText());
    }
  }

  public setFocus() {
    this.apTinyEditor.setFocus();
  }

  onDirtyChanged() {
    console.log('onDirtyChanged');
  }

  public getContent(): string {
    return this.apTinyEditor.getContent();
  }

  public getContentsText(): string {
    return this.apTinyEditor.getContentAsText();
  }
}
